module.exports = __webpack_public_path__ + "img/_Carousel arrow@2x(1).87846754.png";